import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'

const Footer = () => {
  return(
    <footer className="py-5 bg-black">
      <div className="container">
        <aside className="text-white mb-3 d-flex flex-column align-items-center">
          <a href="https://www.instagram.com/schueleraustausch"
             title="schuleraustausch auf instagram"
             className="text-white btn btn-link d-inline-flex align-items-center">
            <FontAwesomeIcon icon={faInstagram} className='big-icon mr-2'/>
            Instagram
          </a>
          <a href="https://www.youtube.com/channel/UCalZHrihmla0DpVERF-7xog"
             title="schuleraustausch auf youtube"
             className="text-white btn-link btn d-inline-flex align-items-center">
            <FontAwesomeIcon icon={faYoutube} className='big-icon mr-2'/>
            YouTube
          </a>
        </aside>
        <nav className="nav d-flex flex-column align-items-center mb-4">
          <a href="https://www.schueleraustausch.net/pages/datenschutz"
             className="nav-link text-white" >Datenschutz</a>
          <a href="https://www.schueleraustausch.net/pages/impressum"
             className="nav-link text-white" >Impressum</a>
        </nav>
        <p className="m-0 text-center text-white small">
          Copyright &copy; Austauschkompass 2021
        </p>
      </div>
    </footer>
  )
}

export default Footer
